import Swiper from 'swiper/bundle';
import 'swiper/css';


export default class Slider {
    constructor() {
        this.swipers = {};
        this.mediaQuery = window.matchMedia('(max-width: 799px)');
        this.$aboutSlider = null;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this._init());
        } else {
            this._init();
        }
    }

    _init() {
        this._setSlider();
        this.mediaQuery.addEventListener('change', () => this._setSlider());
    }

    _setSlider() {
        const $inner = document.querySelector('.about__inner');
        const $cards = $inner ? $inner.querySelector('.about__cards') : null;
        if (!$inner || !$cards) return;

        if (this.mediaQuery.matches) {
            if (this.swipers.about) return;

            if (!this.$aboutSlider) {
                const $slider = document.createElement('div');
                $slider.className = 'about__slider js-about-slider swiper';

                $cards.classList.add('swiper-wrapper');
                for (const $card of $cards.querySelectorAll('.about__card')) {
                    $card.classList.add('swiper-slide');
                }

                $slider.appendChild($cards);

                const $prev = document.createElement('button');
                $prev.type = 'button';
                $prev.className = 'about__nav -prev js-about-prev';
                $prev.setAttribute('aria-label', '前へ');
                const $next = document.createElement('button');
                $next.type = 'button';
                $next.className = 'about__nav -next js-about-next';
                $next.setAttribute('aria-label', '次へ');

                $slider.appendChild($prev);
                $slider.appendChild($next);

                const $header = $inner.querySelector('.about__header');
                $inner.insertBefore($slider, $header ? $header.nextSibling : $inner.firstChild);

                this.$aboutSlider = $slider;
            }

            const originalCount = this._ensureAboutClones($cards);
            const enableLoop = originalCount >= 2;

            this.swipers.about = new Swiper(this.$aboutSlider, {
                loop: enableLoop,
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                loopAdditionalSlides: enableLoop ? originalCount : 0,
                loopedSlides: enableLoop ? originalCount : 0,
                watchOverflow: false,
                navigation: {
                    nextEl: this.$aboutSlider.querySelector('.js-about-next'),
                    prevEl: this.$aboutSlider.querySelector('.js-about-prev'),
                },
                on: {
                    init: (sw) => sw.update(),
                    imagesReady: (sw) => sw.update(),
                    resize: (sw) => sw.update(),
                },
            });
        } else if (this.swipers.about) {
            this.swipers.about.destroy(true, true);
            this.swipers.about = null;
            this._restoreAbout($inner, $cards);
        } else {
            this._restoreAbout($inner, $cards);
        }
    }

    _restoreAbout($inner, $cards) {
        if (!this.$aboutSlider) return;

        $cards.classList.remove('swiper-wrapper');
        for (const $card of $cards.querySelectorAll('.about__card')) {
            $card.classList.remove('swiper-slide');
        }
        for (const $clone of $cards.querySelectorAll('.about__card.is-clone')) {
            $clone.remove();
        }

        const $prev = this.$aboutSlider.querySelector('.js-about-prev');
        const $next = this.$aboutSlider.querySelector('.js-about-next');
        if ($prev) $prev.remove();
        if ($next) $next.remove();

        const $header = $inner.querySelector('.about__header');
        $inner.insertBefore($cards, $header ? $header.nextSibling : $inner.firstChild);

        this.$aboutSlider.remove();
        this.$aboutSlider = null;
    }

    _ensureAboutClones($cards) {
        const $slides = [...$cards.querySelectorAll('.about__card')].filter(
            ($el) => !$el.classList.contains('is-clone')
        );
        const originalCount = $slides.length;
        if (originalCount === 0) return;

        for (const $clone of $cards.querySelectorAll('.about__card.is-clone')) {
            $clone.remove();
        }

        const targetCount = Math.max(8, originalCount * 2);
        const need = targetCount - originalCount;

        for (let i = 0; i < need; i += 1) {
            const $clone = $slides[i % originalCount].cloneNode(true);
            $clone.classList.add('is-clone');
            $cards.appendChild($clone);
        }

        return originalCount;
    }
}
